import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=63433aea&"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPayment.vue?vue&type=style&index=0&id=63433aea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports